<div class="q-and-a">
  <div>
    <h1 class="large white-space-nowrap">
      {{ 'landing.faq.title_line1' | translate }}<br/>{{ 'landing.faq.title_line2' | translate }}
    </h1>
    <div>
      <img src="/assets/imgs/pixie-faq.webp" alt="FAQ" />
    </div>
  </div>
  <div>
    <p-accordion [value]="0">
      @for (question of questions; track $index) {
        <p-accordion-panel [value]="$index">
          <p-accordion-header>
            <ng-template #toggleicon let-active="active">
              @if (active) {
                <i class="pi pi-minus-circle text-xl font-bold p-accordionheader-toggle-icon icon-start"></i>
              } @else {
                <i class="pi pi-plus-circle text-xl font-bold p-accordionheader-toggle-icon icon-start"></i>
              }
            </ng-template>
            <span class="flex items-center gap-2 w-full">
              <span class="font-medium text-lg whitespace-nowrap">
                {{ question.question }}
              </span>
            </span>
          </p-accordion-header>
          <p-accordion-content>
            <span class="line-height-3" [innerHTML]="question.answer | translate"></span>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
</div>
